import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'
import type {
  TodistusPyyntö,
  TodistusPyyntöAet,
  UsageRegion,
} from 'todistukset-common/src/vtj/types/todistus'

export const isUsageRegion = (
  usageRegion: UsageRegion | string
): usageRegion is UsageRegion => typeof usageRegion === 'object'

export const isValueInEnum = <EnumType extends Record<string, unknown>>(
  value: unknown,
  referenceEnum: EnumType
): value is EnumType[keyof EnumType] =>
  Object.values(referenceEnum).includes(value)

export const isValueInArray = <A>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  value: any,
  referenceArray: Readonly<Array<A>>
): value is A => referenceArray.includes(value)

export const isTodistusPyyntoAet = (
  todistusPyynto: TodistusPyyntö
): todistusPyynto is TodistusPyyntöAet => {
  return todistusPyynto.todistusType === CertificateTypes.AETTODISTUS
}

export const isValueInNullableEnum = <EnumType extends Record<string, unknown>>(
  value: unknown,
  referenceEnum: EnumType
): value is EnumType[keyof EnumType] | null =>
  value === null || isValueInEnum(value, referenceEnum)
